
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/u/tools/top-searches-nov-2025",
      function () {
        return require("private-next-pages/u/tools/top-searches-nov-2025.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/u/tools/top-searches-nov-2025"])
      });
    }
  